import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { TuiHintOptionsDirective } from '@taiga-ui/core/directives/hint';
import * as i1 from '@taiga-ui/core/components/icon';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import * as i2 from '@taiga-ui/kit/directives/tooltip';
import { TuiTooltip } from '@taiga-ui/kit/directives/tooltip';

/**
 * @deprecated: drop in v5.0 use {@link TuiTooltip}
 * https://taiga-ui.dev/components/tooltip
 */
class TuiTooltipComponent extends TuiHintOptionsDirective {
    constructor() {
        super(...arguments);
        this.describeId = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiTooltipComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TuiTooltipComponent, selector: "tui-tooltip", inputs: { content: "content", direction: "direction", appearance: "appearance", showDelay: "showDelay", hideDelay: "hideDelay", describeId: "describeId", context: "context" }, usesInheritance: true, ngImport: i0, template: "<tui-icon\n    automation-id=\"tui-tooltip__icon\"\n    [tuiHintAppearance]=\"appearance || ''\"\n    [tuiHintContext]=\"context\"\n    [tuiHintDirection]=\"direction\"\n    [tuiHintHideDelay]=\"hideDelay\"\n    [tuiHintShowDelay]=\"showDelay\"\n    [tuiTooltip]=\"content\"\n    [tuiTooltipDescribe]=\"describeId\"\n/>\n", dependencies: [{ kind: "component", type: i1.TuiIcon, selector: "tui-icon", inputs: ["icon", "background"] }, { kind: "directive", type: i2.TuiTooltip, selector: "tui-icon[tuiTooltip]", inputs: ["size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiTooltipComponent, decorators: [{
            type: Component,
            args: [{ standalone: false, selector: 'tui-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, inputs: ['content', 'direction', 'appearance', 'showDelay', 'hideDelay'], template: "<tui-icon\n    automation-id=\"tui-tooltip__icon\"\n    [tuiHintAppearance]=\"appearance || ''\"\n    [tuiHintContext]=\"context\"\n    [tuiHintDirection]=\"direction\"\n    [tuiHintHideDelay]=\"hideDelay\"\n    [tuiHintShowDelay]=\"showDelay\"\n    [tuiTooltip]=\"content\"\n    [tuiTooltipDescribe]=\"describeId\"\n/>\n" }]
        }], propDecorators: { describeId: [{
                type: Input
            }], context: [{
                type: Input
            }] } });

/**
 * @deprecated: drop in v5.0 use {@link TuiTooltip}
 * https://taiga-ui.dev/components/tooltip
 */
class TuiTooltipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TuiTooltipModule, declarations: [TuiTooltipComponent], imports: [TuiIcon, TuiTooltip], exports: [TuiTooltipComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiTooltipModule, imports: [TuiIcon] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [TuiIcon, TuiTooltip],
                    declarations: [TuiTooltipComponent],
                    exports: [TuiTooltipComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTooltipComponent, TuiTooltipModule };
